import i18n from 'i18next';

const initTranslations = (lang) => {
  return fetch(`/locales/${lang}/translation.json`).then((res) => {
    if (res.status !== 200) {
      console.log('Looks like there was a problem. Status Code: ' + res.status);
      return;
    }
    i18n.changeLanguage(lang).catch((err) => console.log(err));
  });
};

export default initTranslations;
